import React from 'react';
import { generateIcon } from '../generateIcon';

export const IconPlay = generateIcon({
  name: 'Play',
  path: (
    <path d="M29.05 14.3113L11.04 3.29376C10.7364 3.10783 10.3886 3.00632 10.0326 2.99973C9.67661 2.99314 9.32532 3.0817 9.015 3.25626C8.70764 3.42812 8.4516 3.67874 8.2732 3.98235C8.09481 4.28597 8.00051 4.63162 8 4.98376V27.0163C8.00232 27.5445 8.21429 28.0502 8.58933 28.4222C8.96437 28.7942 9.47177 29.002 10 29C10.3687 28.9999 10.7302 28.8982 11.045 28.7063L29.05 17.6888C29.3394 17.5124 29.5786 17.2645 29.7446 16.969C29.9105 16.6734 29.9977 16.3402 29.9977 16.0013C29.9977 15.6623 29.9105 15.3291 29.7446 15.0336C29.5786 14.738 29.3394 14.4902 29.05 14.3138V14.3113ZM10 26.9925V5.00001L27.9788 16L10 26.9925Z" />
  ),
});
